module.exports = __webpack_public_path__ + "static/Chat_esp_mobile-8a74afdfc2da9ac95b8257b09d4a55a8.mp4";